import { mainOrgSegmentedRoutes } from 'modules/main/main.routes';
import { OrgPageContainer } from 'modules/main/pages/Org/OrgPageContainer';
import { useAppRouteParams } from 'utils/routing/useAppRouteParams';

export default function ViewOrgPage() {
  const { orgIdDashSlug } = useAppRouteParams(mainOrgSegmentedRoutes[0]);

  return <OrgPageContainer orgId={orgIdDashSlug.split('-')[0]} />;
}
